<div class="popup">
  <div *ngIf="!eventEdit" class="title">{{ "addEvent" | translate }}</div>
  <div *ngIf="eventEdit" class="title">{{ "editEvent" | translate }}</div>
  <form [formGroup]="eventForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="field-class">
      <span class="field-label">* {{ "eventTitle" | translate }}</span>
      <input 
        type="text" 
        class="input-field" 
        matInput id="call_title" 
        formControlName="call_title" 
        placeholder="Enter event title"
        [ngClass]="{'invalid-field': eventForm.get('call_title')?.invalid && eventForm.get('call_title')?.touched}"
      >
    </div>
    <div class="field-class">
      <span class="field-label">* {{ "vessel" | translate }}</span>
      <p-dropdown 
        [options]="newVesselList" 
        [filter]="true"
        filterBy="dispName"
        [showClear]="false"
        displayProperty="id"
        [(ngModel)]="currVessel" 
        [ngModelOptions]="{standalone: true}"
        optionLabel="dispName"
        placeholder="Select vessel"
        (onChange)="onVesselSelected()"
        [virtualScroll]="true" 
        [virtualScrollItemSize]="38"
        (onHide)="onVesselDropdownOpen()"
        [ngClass]="{'invalid-field': vesselDropdownTouched && !currVessel}"
        [style]="{'width': '100%', 'height': '40px', 'font-size': '16px', 'flex-shrink': '0', 'background-color': 'var(--list-bg-color)', 'padding-left': '5px', 'color': 'var(--text-color)'}"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption >
          <div style="margin-top: -6px; color: black; font-size: 18px;">
            {{ currVessel.dispName }}
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="field-class">
      <span class="field-label">* {{ "equipment" | translate }}</span>
      <p-dropdown 
        [options]="vesselEquipList" 
        [filter]="true"
        filterBy="name"
        [showClear]="false"
        displayProperty="id"
        [(ngModel)]="currEquip" 
        [ngModelOptions]="{standalone: true}"
        optionLabel="name"
        [placeholder]="!currVessel ? 'Please select vessel first' : 'Select equipment'"
        [virtualScroll]="true" 
        [virtualScrollItemSize]="38"
        (onHide)="onEquipDropdownOpen()"
        [ngClass]="{'invalid-field': equipDropdownTouched && !currEquip}"
        [style]="{'width': '100%', 'height': '40px', 'font-size': '16px', 'flex-shrink': '0', 'background-color': 'var(--list-bg-color)', 'padding-left': '5px', 'color': 'var(--text-color)'}"
      >
        <ng-template pTemplate="selectedItem" let-selectedOption >
          <div style="margin-top: -6px; color: black; font-size: 18px;">
            {{ currEquip.name }}
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <div class="field-class">
      <span class="field-label">* {{ "scheduledTime" | translate }}</span>
      <input 
        type="datetime-local" 
        class="input-field" 
        matInput 
        id="scheduled_time" 
        formControlName="scheduled_time" 
        placeholder="Enter scheduled time"
        [ngClass]="{'invalid-field': eventForm.get('scheduled_time')?.invalid && eventForm.get('scheduled_time')?.touched}"
      >
    </div>
    <div class="field-class">
      <span class="field-label">* {{ "duration" | translate }}</span>
      <input 
        type="number"
        class="input-field"
        matInput id="scheduled_duration"
        formControlName="scheduled_duration"
        placeholder="Enter duration"
        min="0"
        [ngClass]="{'invalid-field': eventForm.get('scheduled_duration')?.invalid && eventForm.get('scheduled_duration')?.touched}"
      >
    </div>
    <div class="field-class-large">
      <span class="field-label">{{ "details" | translate }}</span>
      <textarea matInput class="input-area" matInput id="incident_details" formControlName="incident_details" placeholder="Enter details"></textarea>
    </div>
    <div
      style="font-family: Noto Sans JP; margin: -5px 0 10px 30px; color: var(--text-color); font-size: 16px; display: flex;"
    >
      <input
        type="checkbox"
        [checked]="sendEmail === 1"
        (change)="onSendEmailChange($event)"
        style="margin-right: 6px; margin-top: 2px"
      />
      {{ "sendEmailNotification" | translate }}
    </div>
    <div class="join-delete-button-area flex justify-end" *ngIf="eventEdit">
      <button *ngIf="!auth.isYakuin" type="button" (click)="onDelete()" class="delete-button outline-none h-10 rounded">{{ "deleteEvent" | translate }}</button>
      <button [mat-dialog-close] (click)="joinEvent()" class="join-button h-10 rounded">{{ "joinEvent" | translate }}</button>
    </div>
    <div class="button-area flex justify-end">
      <button [mat-dialog-close] class="cancel-button outline-none h-10">{{ "cancel" | translate }}</button>
      <button type="submit" class="save-button h-10 rounded">{{ "save" | translate }}</button>
    </div>
  </form>
</div>
      